import { z } from "zod";
import { ReportIdSchema, ScanIdSchema } from "../primitives/ids.js";
import { PublicEvidenceClassSchema } from "../growth/evidence-class.js";
import { ShareablePublicProblemV1Schema, ShareableReportPrioritySchema, } from "../growth/shareable-report-fields.js";
export const PUBLIC_SCAN_STATUSES = ["PENDING", "PROCESSING", "COMPLETE", "FAILED"];
export const PublicScanStatusKindSchema = z.enum(PUBLIC_SCAN_STATUSES);
/** POST /v1/public/scans request body. */
export const PublicScanRequestV1Schema = z
    .object({
    schemaVersion: z.literal("public-scan-request.v1.0"),
    url: z.string().min(1).max(2048),
})
    .strict();
/** POST /v1/public/scans response. */
export const PublicScanCreateResultV1Schema = z
    .object({
    schemaVersion: z.literal("public-scan-create-result.v1.0"),
    scanId: ScanIdSchema,
    publicReportRef: ReportIdSchema,
    status: PublicScanStatusKindSchema,
})
    .strict();
/** GET /v1/public/scans/:scanId/status response. */
export const PublicScanStatusV1Schema = z
    .object({
    schemaVersion: z.literal("public-scan-status.v1.0"),
    scanId: ScanIdSchema,
    publicReportRef: ReportIdSchema,
    status: PublicScanStatusKindSchema,
    score: z.number().int().min(0).max(100).optional(),
    completedAt: z.string().datetime().optional(),
    failureReason: z.string().min(1).optional(),
})
    .strict();
export const PublicScanTopIssueV1Schema = z
    .object({
    title: z.string().min(1),
    detail: z.string().min(1),
    evidenceClass: PublicEvidenceClassSchema.optional(),
})
    .strict();
/** Client-safe public report view — GET /v1/public/reports/:publicReportRef */
export const PublicExternalScanReportViewV1Schema = z
    .object({
    schemaVersion: z.literal("public-external-scan-report.v1.0"),
    publicReportRef: ReportIdSchema,
    scannedUrl: z.string().url(),
    score: z.number().int().min(0).max(100),
    scoreLabel: z.string().min(1),
    topIssues: z.array(PublicScanTopIssueV1Schema).min(0).max(5),
    problems: z.array(ShareablePublicProblemV1Schema).min(0).max(5),
    reportPriority: ShareableReportPrioritySchema,
    nextActions: z.array(z.string().min(1)).min(1).max(5),
    disclaimers: z.array(z.string().min(1)).min(1),
    generatedAt: z.string().datetime(),
})
    .strict();
export const EXTERNAL_SCAN_RULE_SET_VERSION = "external-scan.v1.0";
/** Worker-persisted internal scan report (never returned on public routes). */
export const ExternalScanReportV1Schema = z
    .object({
    schemaVersion: z.literal("external-scan-report.v1.0"),
    publicReportRef: ReportIdSchema,
    scanId: ScanIdSchema,
    scannedUrl: z.string().url(),
    normalizedUrl: z.string().url(),
    score: z.number().int().min(0).max(100),
    scoreLabel: z.string().min(1),
    topIssues: z.array(PublicScanTopIssueV1Schema).max(5),
    ruleSetVersion: z.literal(EXTERNAL_SCAN_RULE_SET_VERSION),
    checkSummaries: z.array(z
        .object({
        checkId: z.string().min(1),
        status: z.string().min(1),
        clientSafeSummary: z.string().min(1),
    })
        .strict()),
    generatedAt: z.string().datetime(),
    htmlByteLength: z.number().int().nonnegative(),
})
    .strict();
export function publicScanScoreLabel(score) {
    if (score >= 85)
        return "Strong readiness signals";
    if (score >= 70)
        return "Moderate readiness";
    if (score >= 50)
        return "Needs attention";
    return "Significant gaps detected";
}
//# sourceMappingURL=public-scan.js.map